import http from './http';

import {
    MARKETING_COURSE_EVENT_SEARCH_ENDPOINT,
    ADD_MARKETING_LIST_ITEM_ENDPOINT,
    GET_MARKETING_LIST_ITEMS_ENDPOINT,
    REORDER_MARKETING_LIST_ITEMS_ENDPOINT,
    REMOVE_MARKETING_LIST_ITEM_ENDPOINT
} from './endpoints';

export default (() => {

    const getSearchEventsCourses = searchTerm => {
        return http.get(MARKETING_COURSE_EVENT_SEARCH_ENDPOINT, {params: searchTerm});
    }

    const addMarketingListItem = selected => {
        return http.post(ADD_MARKETING_LIST_ITEM_ENDPOINT, selected);
    }

    const getMarketingListItems = () => {
        return http.get(GET_MARKETING_LIST_ITEMS_ENDPOINT);
    }

    const reOrderMarketingListItems = params => {
        return http.put(REORDER_MARKETING_LIST_ITEMS_ENDPOINT, params);
    }

    const removeMarketingListItem = id => {
        return http.delete(REMOVE_MARKETING_LIST_ITEM_ENDPOINT + '/' + id);
    }

    return {
        getSearchEventsCourses,
        addMarketingListItem,
        getMarketingListItems,
        reOrderMarketingListItems,
        removeMarketingListItem
    };

})();


// WEBPACK FOOTER //
// ./services/marketing.js